import { render } from "./StackedBarChart.vue?vue&type=template&id=35c96fca"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"

import "./StackedBarChart.vue?vue&type=style&index=0&id=35c96fca&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__